import { Configuration } from '@azure/msal-browser';

import { AuthorizationSettings } from '../../../site-settings/models';
import { loggerCallback } from './msal-logger-callback';

/**
 * Build MSAL config based on authorization settings
 * @param settings Authorization settings
 */
export const buildMsalConfig = (settings: AuthorizationSettings): Configuration => {
  const { uipAuthorityDomain, uipSignUpSignInPolicy, uipClientId, uipTenantId } = settings;
  return {
    auth: {
      clientId: uipClientId || '',
      authority: `https://${uipAuthorityDomain}/${uipTenantId}/${uipSignUpSignInPolicy}`,
      knownAuthorities: [uipAuthorityDomain ? uipAuthorityDomain : ''],
      redirectUri: location.origin,
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false,
    },
    system: {
      loggerOptions: { loggerCallback },
    },
  };
};
